module.exports = __webpack_public_path__ + "assets/imgs/news-page-img-10.v1.jpeg";